import API from 'app/services/database/databaseApi'
import { getConnectionStatus } from 'app/services/database/connectionStatusResolver'
import { CreateDatabaseModel } from 'app/models/createDatabaseModel'
import {
  AggregatedDatabaseModel,
  DatabaseModel,
} from 'app/models/databaseModel'

/**
 * Wywołania baz danych, wyjęte z thunków razem ze slice'em `databases`.
 *
 * Nie ma tu klucza react-query, bo ekran nie czyta listy z żadnego wspólnego miejsca —
 * trzyma ją we własnym stanie, wypełnianym wartością zwracaną przez pobranie.
 * Zapytanie ma osiem parametrów należących do komponentu (stronicowanie, sortowanie,
 * szukanie, filtry serwera i bazy), więc kluczem byłby jego stan.
 */

/** Mapowanie przeniesione 1:1 z thunka - `status` przechodzi przez resolver. */
export const mapDatabaseFields = (data: any): DatabaseModel => ({
  id: data.id,
  name: data.name,
  login: data.login,
  legacy: data.legacy,
  password: data.password,
  companiesCount: data.companiesCount || 0,
  driversCount: data.driversCount,
  size: data.size,
  serverId: data.serverId,
  serverName: data.serverName,
  serverAddress: data.serverAddress,
  status: getConnectionStatus(data.status),
  createdBy: data.createdBy,
  createdDate: data.createdDate,
  modifiedBy: data.modifiedBy,
  modifiedDate: data.modifiedDate,
  currentVersion: data.currentVersion,
  isCompatibleWithModel: data.isCompatibleWithModel,
  migrationStatus: data.migrationStatus,
  migrationFailedAttempts: data.migrationFailedAttempts,
  migrationStalled: data.migrationStalled,
  lastMigrationErrorMessage: data.lastMigrationErrorMessage,
  lastErrorMessage: data.lastErrorMessage,
})

export const fetchPagedDatabases = async (
  companyId?: string,
  take?: number,
  skip?: number,
  orderBy?: string,
  descending?: boolean,
  searchValue?: string,
  serverId?: number,
  databaseId?: number,
  migrationStalled?: boolean,
): Promise<AggregatedDatabaseModel> => {
  const response = await API.create().getPagedDatabases(
    companyId,
    take,
    skip,
    orderBy,
    descending,
    searchValue,
    serverId,
    databaseId,
    migrationStalled,
  )
  const data = response.content.data
  return {
    databases: (data.databases as any[]).map(mapDatabaseFields),
    databasesCount: data.databasesCount,
    activeDriversCount: data.activeDriversCount,
  }
}

export const addDatabaseRequest = (database: CreateDatabaseModel) =>
  API.create().addDatabase(database)

export const retryDatabaseMigrationRequest = (ids: string[]) =>
  API.create().retryMigration(ids)

export const deleteDatabasesRequest = (ids: string[]) =>
  API.create().deleteDatabase(ids)

/** Kształt błędu, którego oczekują komponenty (sprawdzają `.error`). */
export const toActionError = (error: unknown) => ({
  error: (error as any)?.status?.data?.code,
})
